import { Button, Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Contact } from '../../../sic-lib/types/Contact';
import MenuAddContactTagsRaw from './MenuAddContactTagsRaw';

interface Props {
    contact: Contact;
}

export default function MenuAddContactTags({ contact }: Props) {
    const { classes } = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const [menuId] = React.useState<string>('menu_add_contact_tags');

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Grid
            container
            item
            mr={1}
            mt={1}
            justifyContent="flex-end"
            wrap="wrap"
            spacing={1}
            onKeyDown={e => e.stopPropagation()}
        >
            <Button
                variant="outlined"
                onClick={handleOpen}
                aria-haspopup="true"
                aria-controls={menuId}
                aria-expanded={Boolean(anchorEl)}
                className={classes.button}
                onKeyDown={e => e.stopPropagation()}
            >
                Add Tag
            </Button>
            {Boolean(anchorEl) && (
                <MenuAddContactTagsRaw
                    anchorEl={anchorEl}
                    menuId={menuId}
                    contact={contact}
                    onCloseHandler={handleClose}
                />
            )}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    buttonWrapper: {
        margin: theme.spacing(1, 0),
    },
    button: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        '&:hover': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
            backgroundColor: theme.palette.btnDefault.light,
        },
        color: theme.palette.btnDefault.main,
        textTransform: 'none',
        fontSize: '0.75rem',
        padding: 0,
    },
}));
